export const SET_PAGINATION = "SET_PAGINATION";

export const setPagination = (pagination) => ({
  type: SET_PAGINATION,
  payload: {
    pagination,
  },
});
